import { createTranslations } from '../../utils/create-translations.js';
import { PraiseReasonOptions, FeedbackReasonOptions, SharedReasonOptions, wizardEnTranslations, } from '@momentum/types';
export const wizardHeTranslations = createTranslations(wizardEnTranslations, {
    // Reason Selection Constants (for direct constant value lookup)
    reasonConstants: {
        'collaboration-service': 'שיתוף פעולה / שירות',
        'schedule-agreement': 'לוח זמנים / הסכמות',
        communication: 'תקשורת',
        'information-sharing': 'שיתוף מידע',
        'praise-feedback': 'פרגון ומשוב',
        'meeting-expectations': 'עמידה בציפיות',
        'expectations-setting': 'קביעת ציפיות',
    },
    questions: {
        firstQuestion: {
            title: ({ sender }) => `היי ${sender?.personalInfo?.firstName || ''} ${sender?.personalInfo?.firstName ? ', ' : ''} עם מי היית רוצה להתחיל שיחה?`,
            placeholder: 'חפש אנשים מהחברה...',
            validation: 'אנא בחר אדם',
        },
        dateSelection: {
            title: ({ recipient }) => `מתי התרחש האירוע עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
            validation: 'אנא בחר תאריך',
        },
        praiseFeedbackRecipient: {
            validation: 'אנא בחר מי היה הנמען של המשוב',
            options: {
                employees: {
                    title: 'לאחד או יותר מהעובדים האחרים',
                    description: '',
                },
                me: {
                    title: 'אליי',
                    description: '',
                },
            },
        },
        collaborationServiceType: {
            title: 'יש לבחור באחד מהנושאים הבאים',
            description: 'איזה סוג של אינטראקציית שיתוף פעולה או שירות?',
            validation: 'אנא בחר סוג',
            options: {
                serviceResponse: {
                    title: 'מענה שקיבלתי',
                    description: 'שירות או מענה שהתקבל',
                },
                collaboration: {
                    title: 'שיתוף פעולה',
                    description: 'עבודה משותפת על פרויקטים או משימות',
                },
            },
        },
        scheduleAgreementType: {
            title: 'יש לבחור באחד מהנושאים הבאים',
            description: 'איזה סוג של אינטראקציית לוח זמנים או הסכמות?',
            validation: 'אנא בחר סוג',
            options: {
                procedure: {
                    title: 'התנהלות בהתאם לנוהל',
                    description: 'מעקב אחר נהלים ופרוטוקולים קבועים',
                },
                agreementPromise: {
                    title: 'קיום הסכמות או הבטחות',
                    description: 'מעקב אחר התחייבויות שנעשו',
                },
                schedule: {
                    title: 'עמידה בלוח זמנים',
                    description: 'עמידה בדדליינים והתחייבויות זמן',
                },
                goalMeeting: {
                    title: 'עמידה ביעד',
                    description: 'השגת יעדים שנקבעו',
                },
            },
        },
        praiseFeedbackEmployeeSelection: {
            title: 'מי?',
            placeholder: 'בחר עובדים שהיו צריכים לספק משוב',
            validation: 'אנא בחר לפחות עובד אחד',
        },
        verbalExpressionsFrameworkSelection: {
            title: 'באיזו מסגרת הדברים נאמרו?',
            validation: 'אנא בחר מסגרת תקשורת',
        },
        bodyLanguageFrameworkSelection: {
            title: 'באיזו מסגרת הדיון קרה?',
            validation: 'אנא בחר מסגרת דיון',
        },
        writtenCommunicationFrameworkSelection: {
            title: 'באיזו מסגרת הדברים נכתבו?',
            validation: 'אנא בחר מסגרת תקשורת',
        },
        frameworkSelection: {
            validation: 'אנא בחר מסגרת',
            options: {
                oneOnOne: { title: 'בארבע עיניים' },
                meeting: { title: 'בישיבה' },
                casualConversation: { title: 'בשיחת מסדרון' },
                phoneCall: { title: 'בשיחת טלפון' },
                email: { title: 'במייל' },
                instantMessage: { title: 'בווצאפ' },
                socialMedia: { title: 'ברשתות חברתיות' },
                solvePlatform: { title: 'במערכת INTERA' },
                other: { title: 'במסגרת אחרת' },
                notRelevant: { title: 'לא רלוונטי' },
            },
        },
        goals: {
            productivity: {
                title: 'הגברת פרודוקטיביות',
                description: 'הגדלת היעילות ואיכות התפוקה',
            },
            teamwork: {
                title: 'שיפור עבודת צוות',
                description: 'שיפור שיתוף הפעולה ודינמיקת הצוות',
            },
            innovation: {
                title: 'קידום חדשנות',
                description: 'עידוד חשיבה יצירתית ורעיונות חדשים',
            },
            customerSatisfaction: {
                title: 'שביעות רצון לקוחות',
                description: 'שיפור חוויית הלקוח ושביעות הרצון',
            },
            quality: {
                title: 'שמירה על איכות',
                description: 'הבטחת סטנדרטים גבוהים ואספקה איכותית',
            },
        },
        values: {
            integrity: {
                title: 'יושרה',
                description: 'פעולה בכנות ועקרונות מוסריים חזקים',
            },
            collaboration: {
                title: 'שיתוף פעולה',
                description: 'עבודה יחד ביעילות כצוות',
            },
            excellence: {
                title: 'מצוינות',
                description: 'שאיפה לאיכות הגבוהה ביותר בכל מה שאנו עושים',
            },
            innovation: {
                title: 'חדשנות',
                description: 'חיבוק יצירתיות ודרכי חשיבה חדשות',
            },
        },
        companyValues: {
            title: ({ recipient, answers, }) => {
                const reasonToTitle = {
                    communication: `איזה מערכי החברה קודם יותר בזכות אופן התקשורת של ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
                    'collaboration-service': `איזה מערכי החברה קודם יותר בזכות המענה/שירות של ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
                    'information-sharing': `איזה מערכי החברה קודם יותר בזכות המידע ש${recipient?.personalInfo?.firstName || 'האדם הזה'} שיתף?`,
                    'schedule-agreement': `איזה מערכי החברה קודם יותר בזכות עמידתו/ה של ${recipient?.personalInfo?.firstName || 'האדם הזה'} בלוח הזמנים / קיום הסכמות / ביצוע נהלים / עמידה ביעד?`,
                    'praise-feedback': `איזה מערכי החברה קודם יותר בזכות ה I See U וה I Need U של ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
                    'meeting-expectations': `איזה מערכי החברה קודם יותר בזכות עמידתו/ה של ${recipient?.personalInfo?.firstName || 'האדם הזה'} בציפיות?`,
                    default: `איזה מערכי החברה קודם יותר בזכות ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
                };
                return (reasonToTitle[answers?.['reason-selection']] || reasonToTitle.default);
            },
            validation: 'אנא בחר',
        },
    },
    // Praise Questions Wizard (unique praise-specific content)
    praiseQuestions: {
        title: 'אשף פרגון ומשוב',
        description: 'שתף את החוויות החיוביות שלך במקום העבודה',
        praiseSubmittedSuccessfully: 'ה I See U נשלח בהצלחה',
        praiseSubmittedFailed: 'נכשל לשלוח את ה I See U',
        // Praise/Feedback Recipient Selection for Praise Wizard
        praiseFeedbackRecipient: {
            title: ({ recipient, answers, }) => {
                const recipientName = recipient?.personalInfo?.firstName || 'this person';
                const praiseTypeSelection = answers?.['praise-type-selection']?.[0];
                switch (praiseTypeSelection) {
                    case 'praise-and-feedback':
                        return `למי התייחסו ה I See U & I Need U שניתנו מ${recipientName}?`;
                    case 'feedback-only':
                        return `למי התייחס ה I Need U שניתן מ${recipientName}?`;
                    case 'praise-only':
                        return `למי התייחס ה I See U שניתן מ${recipientName}?`;
                    default:
                        return `למי התייחסו ה I See U & I Need U שניתנו מ${recipientName}?`;
                }
            },
        },
        // Praise/Feedback Employee Selection for Praise Wizard
        praiseFeedbackEmployeeSelection: {
            title: 'מי?',
            placeholder: 'בחר עובדים שקיבלו פרגון או משוב',
            validation: 'אנא בחר לפחות עובד אחד',
        },
        reasonSelection: {
            title: ({ recipient }) => `לאיזה עניין מתייחס האירוע שלך עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
            validation: 'אנא בחר סיבה',
            options: {
                collaboration: {
                    title: ({ recipient }) => `מענה שקבלתי מ${recipient?.personalInfo?.firstName || 'האדם הזה'} / שיתוף פעולה עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                scheduleAgreement: {
                    title: ({ recipient }) => `עמידה בלוח זמנים / קיום סיכום / התנהלות בהתאם לנוהל / עמידה ביעד מצד ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                communication: {
                    title: ({ recipient }) => `סגנון התקשורת של ${recipient?.personalInfo?.firstName || 'האדם הזה'} (כולל דברים שנאמרו או נכתבו ומחוות גופניות)`,
                },
                informationSharing: {
                    title: ({ recipient }) => `שיתוף במידע / שיתוף בתהליך קבלת החלטה / מסירת דיווח מצד ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                praiseFeedback: {
                    title: ({ recipient }) => `I See U / I Need U שקיבלתי מ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                meetingExpectations: {
                    title: ({ recipient }) => `עמידה בציפיות על ידי ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
            },
        },
        expectationsDetails: {
            title: ({ recipient }) => `באיזה תחום התקיימה עמידה בציפיות על ידי ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
            placeholder: 'כתוב בקצרה...',
            validation: 'אנא ספק פרטים',
        },
        praiseTypeSelection: {
            title: 'על איזה סוג אירוע מדובר?',
            validation: 'אנא בחר סוג אינטראקציה',
            options: {
                praiseAndFeedback: {
                    title: ({ recipient }) => `ל I See U & I Need U שניתנו מ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                feedbackOnly: {
                    title: ({ recipient }) => `ל I Need U שניתן מ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                praiseOnly: {
                    title: ({ recipient }) => `ל I See U שניתן מ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
            },
        },
        collaborationServiceType: {
            title: 'איזה סוג שיתוף פעולה או שירות?',
            validation: 'אנא בחר סוג',
            options: {
                serviceResponse: {
                    title: ({ recipient }) => `מענה שקיבלתי מ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'מענה לבקשת שירות',
                },
                collaboration: {
                    title: ({ recipient }) => `שיתוף פעולה עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'עבודה משותפת על פרויקט או משימה',
                },
            },
        },
        communicationType: {
            title: 'איזה היבט של תקשורת?',
            validation: 'אנא בחר סוג תקשורת',
            options: {
                speechTone: {
                    title: ({ recipient }) => `סגנון הדיבור והטונציה של ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'הטון והאופן של הדיבור',
                },
                generalConduct: {
                    title: ({ recipient }) => `ההתנהלות כללית של ${recipient?.personalInfo?.firstName || 'האדם הזה'} במהלך הדיון`,
                    description: 'התנהגות מקצועית כוללת',
                },
                bodyLanguage: {
                    title: ({ recipient }) => `מחוות גופנית של ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'שפות גוף, הבעת פנים ועוד',
                },
                writtenMessages: {
                    title: ({ recipient }) => `דברים שנכתבו על ידי ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'דברים שנכתבו במיילים, הודעות וכו',
                },
                verbalExpressions: {
                    title: ({ recipient }) => `דברים שנאמרו על ידי ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'דברים שנאמרו בעל פה בשיחות',
                },
            },
        },
        scheduleAgreementType: {
            title: 'איזה סוג לוח זמנים או הסכמה?',
            validation: 'אנא בחר סוג',
            options: {
                procedure: {
                    title: 'התנהלות בהתאם לנוהל',
                    description: 'ביצוע נהלים קבועים',
                },
                agreementPromise: {
                    title: 'קיום סיכומים או הבטחה',
                    description: 'קיום הסכמות והבטחות',
                },
                schedule: {
                    title: 'עמידה בלוח זמנים',
                    description: 'ניהול זמן ולוחות זמנים ביעילות',
                },
                goalMeeting: {
                    title: 'עמידה ביעד',
                    description: 'עמידה ביעדים ובמטרות',
                },
            },
        },
        frameworkSelection: {
            title: ({ answers, recipient, }) => {
                // Check which flow we're in based on previous steps
                if (answers?.['collaboration-service-type']) {
                    if (answers?.['collaboration-service-type']?.[0] === 'collaboration') {
                        return `באיזו מסגרת התקיים השיתוף פעולה שלך עם  ${recipient?.personalInfo?.firstName || 'this person'}?`;
                    }
                    if (answers?.['collaboration-service-type']?.[0] === 'service-response') {
                        return `באיזו מסגרת קיבלת את המענה מ${recipient?.personalInfo?.firstName || 'this person'}?`;
                    }
                }
                if (answers?.['communication-type-selection']) {
                    return 'באיזו מסגרת הדיון התקיים?';
                }
                // Check if this is from the praise wizard expectations flow
                if (answers?.['reason-selection']?.[0] === 'meeting-expectations') {
                    return `באיזו מסגרת התקיימה העמידה בציפיות על ידי ${recipient?.personalInfo?.firstName || 'this person'}?`;
                }
                if (answers?.['reason-selection']?.[0] === 'praise-feedback') {
                    if (answers?.['praise-type-selection']?.[0] === 'praise-and-feedback') {
                        return 'באיזו מסגרת ניתנו ה I See U & I Need U ?';
                    }
                    if (answers?.['praise-type-selection']?.[0] === 'feedback-only') {
                        return 'באיזו מסגרת ניתן ה I Need U ?';
                    }
                    if (answers?.['praise-type-selection']?.[0] === 'praise-only') {
                        return 'באיזו מסגרת ניתן ה I See U ?';
                    }
                }
                if (answers?.['reason-selection']?.[0] === 'information-sharing') {
                    if (answers['information-sharing-type']?.[0] === 'general-info') {
                        return 'באיזו מסגרת התקיים השיתוף במידע?';
                    }
                    if (answers['information-sharing-type']?.[0] === 'reporting') {
                        return 'באיזו מסגרת נמסר הדיווח?';
                    }
                    if (answers['information-sharing-type']?.[0] === 'decision-making') {
                        return 'באיזו מסגרת התקיים השיתוף בתהליך קבלת החלטה?';
                    }
                }
                return 'באיזו מסגרת זה התקיים?';
            },
        },
        goalSelection: {
            title: ({ recipient, answers, }) => {
                const reasonToTitle = {
                    communication: `באיזה יעד שלך תומך אופן התקשורת של ${recipient?.personalInfo?.firstName || 'this person'} במהלך הדיון?`,
                    'meeting-expectations': `באיזה יעד שלך תומכת העמידה בציפיות על ידי ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    default: `Which one of your goals is affected by ${recipient?.personalInfo?.firstName || 'this person'}?`,
                };
                const scheduleAgreementTypeToTitle = {
                    procedure: `באיזה יעד שלך תומכת ההתנהלות של ${recipient?.personalInfo?.firstName || 'this person'} בהתאם לנוהל?`,
                    'agreement-promise': `באיזה יעד שלך תומך קיום הסיכום או ההבטחה מצד ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    schedule: `באיזה יעד שלך תומכת העמידה בלוח הזמנים של ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'goal-meeting': `באיזה יעד שלך תומכת העמידה ביעד מצד ${recipient?.personalInfo?.firstName || 'this person'}?`,
                };
                const collaborationServiceTypeToTitle = {
                    'service-response': `באיזה יעד שלך תומך המענה שקיבלת מ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    collaboration: `באיזה יעד שלך תומך שיתוף הפעולה שלך עם  ${recipient?.personalInfo?.firstName || 'this person'}?`,
                };
                const informationSharingTypeToTitle = {
                    'general-info': `באיזה יעד שלך תומך שיתוף המידע מצד ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    reporting: `באיזה יעד שלך תומכת מסירת הדיווח מצד  ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'decision-making': `באיזה יעד שלך תומך השיתוף בתהליך קבלת ההחלטה מצד ${recipient?.personalInfo?.firstName || 'this person'}?`,
                };
                const praiseFeedbackTypeToTitle = {
                    'praise-only': `באיזה יעד שלך תומך ה I See U שניתן מ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'feedback-only': `באיזה יעד שלך תומך ה I Need U שניתן מ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'praise-and-feedback': `באיזה יעד שלך תומכים ה I See U & I Need U שניתנו מ${recipient?.personalInfo?.firstName || 'this person'}?`,
                };
                if (answers?.['reason-selection']?.[0] === 'collaboration-service') {
                    return collaborationServiceTypeToTitle[answers?.['collaboration-service-type']?.[0]];
                }
                if (answers?.['reason-selection']?.[0] === 'schedule-agreement') {
                    return scheduleAgreementTypeToTitle[answers?.['schedule-agreement-type']?.[0]];
                }
                if (answers?.['reason-selection']?.[0] === 'information-sharing') {
                    return informationSharingTypeToTitle[answers?.['information-sharing-type']?.[0]];
                }
                if (answers?.['reason-selection']?.[0] === 'praise-feedback') {
                    return praiseFeedbackTypeToTitle[answers?.['praise-type-selection']?.[0]];
                }
                return (reasonToTitle[answers?.['reason-selection']?.[0]] || reasonToTitle.default);
            },
            validation: 'אנא בחר יעד',
        },
        goalImpactRange: {
            title: 'באיזו מידה הסיכויים שלך להשיג את היעד שלך השתפרו?',
            minLabel: 'השפעה נמוכה',
            maxLabel: 'השפעה גבוהה',
            validation: 'אנא דרג את ההשפעה',
        },
        additionalEffectsTemp: {
            title: 'באיזה דרכים נוספות האירוע הזה השפיע עליך',
            validation: 'אנא בחר לפחות השפעה אחת',
            options: {
                energy: {
                    title: 'תרם לחיסכון או לעלייה ברמת האנרגיה שלי',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} תרמה לחיסכון או לעלייה ברמת האנרגיה שלך, ביחס ל${impacted}`,
                    afterSend: (name, impacted) => `תרמת לחיסכון או לעלייה ברמת האנרגיה של ${name}, ביחס ל${impacted}`,
                },
                confidence: {
                    title: 'העצים את תחושת הביטחון שלי',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} העצימה את תחושת הביטחון שלך, ביחס ל${impacted}`,
                    afterSend: (name, impacted) => `העצמת את תחושת הביטחון של ${name}, ביחס ל${impacted}`,
                },
                connection: {
                    title: 'העצים את תחושת הקרבה בינינו',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את תחושת הקרבה בינך לבין ${name}`,
                    afterSend: (name) => `העצמת את תחושת הקרבה בינך לבין ${name}`,
                },
                reputation: {
                    title: 'העלה את המוניטין המקצועי שלי',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} העלתה את המוניטין המקצועי שלך, בעיני ${impacted}`,
                    afterSend: (name, impacted) => `העלית את המוניטין המקצועי של ${name}, בעיני ${impacted}`,
                },
                meaningful: {
                    title: 'העצים את תחושת המשמעות שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את תחושת המשמעות שלך`,
                    afterSend: (name) => `העצמת את תחושת המשמעות של ${name}`,
                },
                belonging: {
                    title: 'העצים את תחושת השייכות שלי',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} העצימה את תחושת השייכות שלך, ביחס ל${impacted}`,
                    afterSend: (name, impacted) => `העצמת את תחושת השייכות של ${name}, ביחס ל${impacted}`,
                },
                responsibility: {
                    title: 'העצים את היכולת שלי ליזום ולקחת יותר אחריות',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} העצימה את היכולת שלך ליזום ולקחת יותר אחריות מול ${impacted}`,
                    afterSend: (name, impacted) => `העצמת את היכולת של ${name} ליזום ולקחת יותר אחריות, מול ${impacted}`,
                },
                learning: {
                    title: 'העצים את היכולת שלי ללמוד ולהתפתח',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את היכולת שלך ללמוד ולהתפתח`,
                    afterSend: (name) => `העצמת את היכולת של ${name} ללמוד ולהתפתח`,
                },
                'no-other-effects': {
                    title: 'לא תרם לי מבחינות נוספות',
                },
            },
        },
        additionalEffects: {
            title: 'באיזה דרכים נוספות האירוע הזה השפיע עליך',
            validation: 'אנא בחר לפחות השפעה אחת',
            options: {
                energy: {
                    title: 'תרם לחיסכון או לעלייה ברמת האנרגיה שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} תרמה לחיסכון או לעלייה ברמת האנרגיה שלך`,
                    afterSend: (name) => `תרמת לחיסכון או לעלייה ברמת האנרגיה של ${name}`,
                },
                confidence: {
                    title: 'העצים את תחושת הביטחון שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את תחושת הביטחון שלך`,
                    afterSend: (name) => `העצמת את תחושת הביטחון של ${name}`,
                },
                connection: {
                    title: 'העצים את תחושת הקרבה בינינו',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את תחושת הקרבה בינך לבין ${name}`,
                    afterSend: (name) => `העצמת את תחושת הקרבה בינך לבין ${name}`,
                },
                reputation: {
                    title: 'העלה את המוניטין המקצועי שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} העלתה את המוניטין המקצועי שלך`,
                    afterSend: (name) => `העלית את המוניטין המקצועי של ${name}`,
                },
                meaningful: {
                    title: 'העצים את תחושת המשמעות שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את תחושת המשמעות שלך`,
                    afterSend: (name) => `העצמת את תחושת המשמעות של ${name}`,
                },
                belonging: {
                    title: 'העצים את תחושת השייכות שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את תחושת השייכות שלך`,
                    afterSend: (name) => `העצמת את תחושת השייכות של ${name}`,
                },
                responsibility: {
                    title: 'העצים את היכולת שלי ליזום ולקחת יותר אחריות',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את היכולת שלך ליזום ולקחת יותר אחריות`,
                    afterSend: (name) => `העצמת את היכולת של ${name} ליזום ולקחת יותר אחריות`,
                },
                learning: {
                    title: 'העצים את היכולת שלי ללמוד ולהתפתח',
                    beforeSend: (name) => `ההתנהלות של ${name} העצימה את היכולת שלך ללמוד ולהתפתח`,
                    afterSend: (name) => `העצמת את היכולת של ${name} ללמוד ולהתפתח`,
                },
                'no-other-effects': {
                    title: 'לא תרם לי מבחינות נוספות',
                },
            },
        },
        companyValues: {
            title: 'האם זה תורם לערכי החברה?',
            description: 'בחר אם האינטראקציה הזו חיזקה ערכי חברה כלשהם',
            validation: 'אנא בחר',
        },
        goals: {
            productivity: {
                title: 'הגברת פרודוקטיביות',
                description: 'הגדלת היעילות ואיכות התפוקה',
            },
            teamwork: {
                title: 'שיפור עבודת צוות',
                description: 'שיפור שיתוף הפעולה ודינמיקת הצוות',
            },
            innovation: {
                title: 'קידום חדשנות',
                description: 'עידוד חשיבה יצירתית ורעיונות חדשים',
            },
            customerSatisfaction: {
                title: 'שביעות רצון לקוחות',
                description: 'שיפור חוויית הלקוח ושביעות הרצון',
            },
            quality: {
                title: 'שמירה על איכות',
                description: 'הבטחת סטנדרטים גבוהים ואספקה איכותית',
            },
        },
        values: {
            integrity: {
                title: 'יושרה',
                description: 'פעולה בכנות ועקרונות מוסריים חזקים',
            },
            collaboration: {
                title: 'שיתוף פעולה',
                description: 'עבודה יחד ביעילות כצוות',
            },
            excellence: {
                title: 'מצוינות',
                description: 'שאיפה לאיכות הגבוהה ביותר בכל מה שאנו עושים',
            },
            innovation: {
                title: 'חדשנות',
                description: 'חיבוק יצירתיות ודרכי חשיבה חדשות',
            },
        },
        informationSharingType: {
            title: 'באיזה סוג של שיתוף במידע מדובר?',
            validation: 'אנא בחר סוג',
            options: {
                generalInfo: {
                    title: 'שיתוף במידע כללי',
                    description: 'שיתוף ידע או מידע כללי',
                },
                reporting: {
                    title: 'מסירת דיווח',
                    description: 'מתן דוחות או עדכוני סטטוס',
                },
                decisionMaking: {
                    title: 'שיתוף בתהליך קבלת החלטה הנוגעת לחתום אחריותי',
                    description: 'הכללה שלך בתהליכי קבלת החלטות',
                },
            },
        },
        // Subject detail steps
        praiseFeedbackSubject: {
            title: ({ answers, recipient, }) => {
                const praiseFeedbackSubject = answers?.['praise-type-selection']?.[0];
                switch (praiseFeedbackSubject) {
                    case 'praise-and-feedback':
                        return `באיזה נושא עסקו ה I See U & I Need U שניתנו מ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`;
                    case 'feedback-only':
                        return `באיזה נושא עסק ה I Need U שניתן מ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`;
                    case 'praise-only':
                        return `באיזה נושא עסק ה I See U שניתן מ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`;
                    default:
                        return `באיזה נושא עסקו ה I See U & I Need U שניתנו מ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`;
                }
            },
            placeholder: 'כתוב בקצרה על הנושא...',
            validation: 'אנא תאר את הנושא',
        },
        feedbackSubject: {
            title: 'באיזה נושא עסק המשוב?',
            description: 'תאר את הנושא או התחום שהמשוב כיסה',
            placeholder: 'כתוב בקצרה על הנושא...',
            validation: 'אנא תאר את הנושא',
        },
        praiseSubject: {
            title: 'באיזה נושא עסק הפרגון?',
            description: 'תאר את הנושא או התחום שהפרגון כיסה',
            placeholder: 'כתוב בקצרה על הנושא...',
            validation: 'אנא תאר את הנושא',
        },
        // Framework steps
        serviceFramework: {
            title: ({ recipient }) => `באיזו מסגרת קיבלת את המענה/השירות מ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
            description: 'בחר את ההקשר שבו קיבלת את השירות או המענה',
            validation: 'אנא בחר מסגרת',
        },
        serviceDescription: {
            title: ({ recipient }) => ` איזה מענה קיבלת מ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
            placeholder: 'כתוב בקצרה על השירות...',
            validation: 'אנא תאר את השירות',
        },
        collaborationFramework: {
            title: ({ recipient }) => ` באיזו מסגרת התקיים שיתוף הפעולה עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
            description: 'בחר את ההקשר שבו התרחש שיתוף הפעולה',
            validation: 'אנא בחר מסגרת',
        },
        collaborationDescription: {
            title: 'באיזה סוג של שיתוף פעולה מדובר',
            description: 'איזה סוג של שיתוף פעולה חווית?',
            placeholder: 'כתוב בקצרה על שיתוף הפעולה...',
            validation: 'אנא תאר את שיתוף הפעולה',
        },
        // Information Sharing Details Step (Dynamic)
        informationSharingDetails: {
            validation: 'אנא ספק פרטים',
            title: ({ answers }) => {
                const infoTypeToTitle = {
                    'general-info': 'באיזה מידע מדובר?',
                    reporting: 'מה היה נושא הדיווח?',
                    'decision-making': 'באיזו החלטה מדובר?',
                    generic: 'אנא ספק פרטים',
                };
                const infoType = answers?.['information-sharing-type'];
                return infoTypeToTitle[infoType] || infoTypeToTitle.generic;
            },
        },
        // Information Sharing Framework Step (Dynamic)
        informationSharingFramework: {
            description: 'בחר את ההקשר בו זה התקיים',
            validation: 'אנא בחר מסגרת',
            title: ({ answers }) => {
                const infoTypeToTitle = {
                    'general-info': 'באיזו מסגרת התקיים השיתוף במידע?',
                    reporting: 'באיזו מסגרת נמסר הדיווח?',
                    'decision-making': 'באיזו מסגרת התקיים השיתוף בתהליך קבלת ההחלטה?',
                    generic: 'באיזו מסגרת זה התקיים?',
                };
                const infoType = answers?.['information-sharing-type'];
                return infoTypeToTitle[infoType] || infoTypeToTitle.generic;
            },
        },
        // Communication details
        speechToneDetails: {
            title: ({ recipient }) => `לאיזה היבט בסגנון הדיבור של ${recipient?.personalInfo?.firstName || 'האדם הזה'} האירוע שבחרת לציין מתייחס?`,
            description: 'בחר את ההיבט הספציפי בסגנון הדיבור',
            validation: 'אנא בחר היבט',
            options: {
                enthusiastic: {
                    title: 'דיבור באופן סוחף ולא מונוטוני',
                    description: 'דרך דיבור מעניינת ואנרגטית',
                },
                quickFluent: {
                    title: 'דיבור בקצב מהיר וקולח',
                    description: 'תקשורת ברורה וחלקה',
                },
                calm: {
                    title: 'דיבור בטון רגוע',
                    description: 'דרך דיבור שלווה ורגועה',
                },
                appropriateLaughter: {
                    title: 'צחוק במקומות הנכונים',
                    description: 'שימוש בהומור וצחוק ברגעים המתאימים',
                },
                humor: {
                    title: 'שילוב הומור בדברים שנאמרו',
                    description: 'הכללת הומור מתאים בשיחה',
                },
            },
        },
        generalConductDetails: {
            title: ({ recipient }) => `לאיזה היבט בהתנהלות הכללית של ${recipient?.personalInfo?.firstName || 'האדם הזה'} האירוע הנדון מתייחס?`,
            description: 'בחר את ההיבט הספציפי בהתנהלות הכללית',
            validation: 'אנא בחר היבט התנהלות',
            options: {
                checkedFacts: {
                    title: 'ביטוי העובדות לפני נקיטת עמדה והבעת דעה',
                    description: '',
                },
                arrivedOnTime: {
                    title: 'הגעת בזמן לישיבה',
                    description: '',
                },
                involvedContributed: {
                    title: 'מעורבות ותרומה לדיון',
                    description: '',
                },
                acknowledgedViewpoint: {
                    title: 'השתדלות להבין את נקודת המבט של האחר/ים',
                    description: '',
                },
                focusedConversation: {
                    title: 'התמקדות בשיח ובדובר/ים',
                    description: '',
                },
                keptTopic: {
                    title: 'לא היו דילוגים מנושא לנושא',
                    description: '',
                },
                keptTime: {
                    title: 'הצגת הדברים נעשתה במסגרת הזמן שהוקצתה',
                    description: '',
                },
                noInterrupting: {
                    title: 'אי קטיעת דברי האחר/ים',
                    description: '',
                },
            },
        },
        bodyLanguageDetails: {
            title: ({ recipient }) => `לאיזו מחווה גופנית של ${recipient?.personalInfo?.firstName || 'האדם הזה'} האירוע שלך מתייחס?`,
            description: 'בחר את המחווה או שפת הגוף הספציפית',
            validation: 'אנא בחר מחווה',
            options: {
                handShake: {
                    title: 'לחיצת ידיים',
                    description: '',
                },
                namaste: {
                    title: 'נמסטה',
                    description: '',
                },
                hug: {
                    title: 'חיבוק',
                    description: '',
                },
                thumbsUp: {
                    title: 'לייק',
                    description: 'אגודל למעלה',
                },
                handClap: {
                    title: 'מחיאות כפיים',
                    description: '',
                },
                highFive: {
                    title: 'כיף',
                    description: 'high five',
                },
                smile: {
                    title: 'חיוך',
                    description: '',
                },
            },
        },
        writtenMessagesDetails: {
            title: ({ recipient }) => `אילו מילים או משפטים נכתבו על ידי ${recipient?.personalInfo?.firstName || 'הם'}?`,
            description: 'אנא צטט/י במדויק מה נכתב באירוע הנדון',
            placeholder: 'נסה לצטט במדויק מה נכתב...',
            validation: 'אנא ספק פרטים על מה שנכתב',
        },
        writtenMessagesFramework: {
            title: 'באיזו מסגרת הדברים נכתבו?',
            description: 'בחר את האמצעי שדרכו נכתבה ההודעה',
            validation: 'אנא בחר מסגרת',
        },
        verbalExpressionsDetails: {
            title: ({ recipient }) => `אילו מילים או משפטים נאמרו על ידי ${recipient?.personalInfo?.firstName || 'הם'}?`,
            description: 'אנא צטט/י בדיוק אילו מילים נאמרו ',
            placeholder: 'נסה לצטט במדויק מה נאמר...',
            validation: 'אנא ספק פרטים על מה שנאמר',
        },
        // Schedule Agreement Details Step (Dynamic)
        scheduleAgreementDetails: {
            validation: 'אנא ספק פרטים',
            title: ({ answers }) => {
                const scheduleTypeToTitle = {
                    procedure: 'על איזה נוהל מדובר?',
                    'agreement-promise': 'מה סוכם או הובטח?',
                    schedule: 'מהו לוח הזמנים שסוכם עליו?',
                    'goal-meeting': 'באיזה יעד מדובר?',
                    generic: 'אנא ספק פרטים',
                };
                const scheduleType = answers?.['schedule-agreement-type'];
                return scheduleTypeToTitle[scheduleType] || scheduleTypeToTitle.generic;
            },
        },
        // Additional Effects Follow-up Step (Generic)
        additionalEffectsDetails: {
            title: ({ answers }) => {
                const selectedEffects = answers?.['additional-effects'];
                if (Array.isArray(selectedEffects)) {
                    const followUpOptions = [
                        'energizes',
                        'confidence',
                        'reputation',
                        'belonging',
                        'responsibility',
                    ];
                    const selectedFollowUps = selectedEffects.filter((effect) => followUpOptions.includes(effect));
                    if (selectedFollowUps.length > 0) {
                        // Sort effects in consistent order
                        const sortedEffects = selectedFollowUps.sort((a, b) => {
                            return followUpOptions.indexOf(a) - followUpOptions.indexOf(b);
                        });
                        // Map effect keys to Hebrew names
                        const effectNames = {
                            energizes: 'אנרגיה',
                            confidence: 'ביטחון',
                            reputation: 'מוניטין',
                            belonging: 'שייכות',
                            responsibility: 'אחריות',
                        };
                        // Handle single vs multiple effects
                        if (sortedEffects.length === 1) {
                            const singleEffectTitles = {
                                energizes: 'ביחס למי זה הוסיף לך אנרגיה?',
                                confidence: 'ביחס למי זה הגביר את הביטחון שלך?',
                                reputation: 'בעיני מי זה העלה את המוניטין שלך?',
                                belonging: 'ביחס למי זה הגביר את תחושת השייכות שלך?',
                                responsibility: 'ביחס למי זה העצים אותך לקחת יותר אחריות?',
                            };
                            return (singleEffectTitles[sortedEffects[0]] ||
                                'ביחס למי ההשפעות החיוביות הללו חלות?');
                        }
                        else {
                            // For multiple effects, build the title dynamically
                            const effectsText = sortedEffects
                                .map((effect) => effectNames[effect])
                                .join(', ');
                            // Replace the last comma with 'ו' (Hebrew 'and')
                            const lastComma = effectsText.lastIndexOf(', ');
                            const formattedEffects = lastComma !== -1
                                ? effectsText.substring(0, lastComma) +
                                    ' ו' +
                                    effectsText.substring(lastComma + 2)
                                : effectsText;
                            return `ביחס למי ההשפעות הללו (${formattedEffects}) חלות?`;
                        }
                    }
                }
                // Fallback to generic title
                return 'ביחס למי ההשפעות החיוביות הללו חלות?';
            },
            validation: 'אנא בחר אפשרות',
        },
        // Relation Options (shared across multiple follow-up questions)
        relationOptions: {
            everyone: 'באופן כללי, ביחס כולם',
            recipient: 'ביחס לאדם הזה',
            employees: 'ביחס לעובד/ים שלי',
            customers: 'ביחס ללקוח/ות שלי',
            suppliers: 'ביחס לספק/ים שלי',
            manager: 'ביחס למנהל שלי',
            team: 'ביחס לצוות המשותף שלי ושל האדם הזה',
            colleagues: 'ביחס לעמית/ים שלי',
            seniorManagement: 'ביחס להנהלה הבכירה',
        },
        // Reputation specific options (slightly different wording)
        reputationOptions: {
            everyone: 'באופן כללי, בעיני כולם',
            recipient: 'בעיני האדם הזה',
            employees: 'בעיני עובד/ים שלי',
            customers: 'בעיני לקוח/ות שלי',
            suppliers: 'בעיני ספק/ים שלי',
            manager: 'בעיני המנהל שלי',
            team: 'בעיני הצוות המשותף שלי ושל האדם הזה',
            colleagues: 'בעיני עמית/ים שלי',
            seniorManagement: 'בעיני ההנהלה הבכירה',
        },
        praiseFeedbackFramework: {
            title: 'באיזו מסגרת ניתנו הפרגון והמשוב?',
            description: 'בחר את ההקשר שבו הועבר הפרגון והמשוב',
            validation: 'אנא בחר מסגרת',
        },
        success: {
            title: '🎉 תודה לך על השיתוף!',
            description: 'הפרגון והמשוב שלך נרשמו בהצלחה.',
        },
        review: {
            title: {
                creator: 'I See U',
                receiver: 'עבודה מעולה {{employeeName}}!',
            },
            subtitle: {
                creator: 'בחרת להתחיל שיחה עם {{employeeName}}',
                receiver: 'קיבלת I See U מ{{employeeName}}',
            },
            description: 'הדברים שתמצאו כאן נכתבו במיוחד עבורכם. הם משקפים הערכה כנה לפעולות שלכם ולהשפעה החיובית שיצרתם.',
            date: 'מועד האירוע שאליו מתייחסת השיחה',
            reason: 'נושא השיחה',
            additionalEffectsTitle: 'השלכות נוספת',
            companyValues: 'ערכי החברה שקודמו בעקבות אירוע זה',
            edit: 'עריכה',
            saveDraft: 'שמירה כטיוטה',
            reasonDetails: 'תיאור האירוע',
            goal: {
                title: {
                    creator: 'ההשפעה של האירוע על ההצלחה שלך',
                    receiver: 'ההשפעה של האירוע על ההצלחה של {{employeeName}}',
                },
                prefixBeforeSend: {
                    creator: 'הסיכויים שלך לעמוד ביעד',
                    receiver: 'הסיכויים של {{employeeName}} לעמוד ביעד',
                },
                prefixAfterSend: ' הסיכויים של {{employeeName}} לעמוד ביעד',
                affection: 'השתפרו',
            },
            send: 'שלח',
            sending: 'שולח...',
            reasonPrefixes: {
                'collaboration-service': 'תגובה/שירות שהתקבל מ',
                'schedule-agreement': 'בעיית לוח זמנים/הסכם עם',
                communication: 'בעיית תקשורת עם',
                'information-sharing': 'שיתוף מידע עם',
                'decision-making': 'תהליך קבלת החלטות עם',
                reporting: 'בעיית דיווח עם',
                'other-information': 'מידע אחר מ',
                'expectations-setting': 'הגדרת ציפיות עם',
            },
            additionalEffectsPrefix: 'גורם לך להרגיש',
            additionalEffectsMap: {
                energizes: 'אנרגיה',
                confidence: 'ביטחון',
                connection: 'שייכות',
                reputation: 'מוניטין',
                meaningful: 'משמעותי',
            },
        },
    },
    // Feedback Questions Wizard (unique feedback-specific content)
    feedbackQuestions: {
        title: 'אשף משוב ופיתוח',
        description: 'שתף משוב בונה לשיפור מקום העבודה',
        feedbackSubmittedSuccessfully: 'ה I Need U נשלח בהצלחה',
        feedbackSubmittedFailed: 'נכשל לשלוח את ה I Need U',
        // Praise/Feedback Recipient Selection for Feedback Wizard
        praiseFeedbackRecipient: {
            title: ({ recipient, answers, }) => {
                const recipientName = recipient?.personalInfo?.firstName || 'האדם הזה';
                const praiseFeedbackSubject = answers?.['praise-feedback-subject-selection'];
                switch (praiseFeedbackSubject?.[0]) {
                    case 'praise-expected-not-received':
                        return `למי ציפית שיינתן I See U מ${recipientName}?`;
                    case 'feedback-expected-not-received':
                        return `למי ציפית שיינתן I Need U מ${recipientName}?`;
                    case 'inappropriate-feedback-received':
                        return `מי קיבל I Need U לא מתאים מ${recipientName}?`;
                    default:
                        return `מי קיבל I See U ו/או I Need U לא מספיק ברור?`;
                }
            },
        },
        // Praise/Feedback Subject Description for Feedback Wizard
        praiseFeedbackSubjectDescription: {
            title: ({ recipient, answers, }) => {
                const recipientName = recipient?.personalInfo?.firstName || 'האדם הזה';
                const praiseFeedbackSubject = answers?.['praise-feedback-subject-selection'];
                switch (praiseFeedbackSubject?.[0]) {
                    case 'praise-expected-not-received':
                        return `באיזה נושא ציפית שיינתן I See U מ${recipientName}`;
                    case 'feedback-expected-not-received':
                        return `באיזה נושא ציפית שיינתן I Need U ?`;
                    case 'inappropriate-feedback-received':
                        return `תאר את ה I Need U שקיבלת בצורה לא מתאימה`;
                    default:
                        return `תאר את ה I See U / I Need U שהיית מצפה לו?`;
                }
            },
            description: 'בקצרה',
            validation: 'אנא תאר את הנושא',
        },
        // Praise/Feedback Employee Selection for Feedback Wizard
        praiseFeedbackEmployeeSelection: {
            title: 'מי?',
            placeholder: 'בחר עובדים שהיו צריכים לספק משוב',
            validation: 'אנא בחר לפחות עובד אחד',
        },
        collaborationServiceType: {
            title: 'יש לבחור באחד מהנושאים הבאים',
            validation: 'אנא בחר סוג',
            options: {
                serviceNotReceived: {
                    title: 'מענה שלא התקבל',
                    description: 'ציפיתי לשירות אבל לא קיבלתי אותו',
                },
                serviceReceived: {
                    title: 'מענה שהתקבל',
                    description: 'קיבלתי שירות אבל הוא לא פתר את הבעיה שלי',
                },
                collaborationNotHappened: {
                    title: ({ recipient }) => `שיתוף פעולה שלא התקיים עם  ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'ציפיתי לשיתוף פעולה אבל זה לא קרה',
                },
                collaborationHappened: {
                    title: ({ recipient }) => `שיתוף פעולה שהתקיים עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'שיתוף פעולה התרחש אבל הוא לא פתר את הבעיה שלי',
                },
            },
        },
        scheduleAgreementType: {
            title: 'יש לבחור באחד מהנושאים הבאים',
            validation: 'אנא בחר סוג',
            options: {
                goalNotMet: {
                    title: 'אי עמידה ביעד',
                    description: 'יעד או מטרה לא הושגו',
                },
                scheduleNotKept: {
                    title: 'אי עמידה בלוח זמנים',
                    description: 'דדליינים או התחייבויות זמן לא נעמדו',
                },
                agreementNotKept: {
                    title: 'אי קיום סיכום או הבטחה ',
                    description: 'הבטחות או התחייבויות לא בוצעו',
                },
                procedureNotFollowed: {
                    title: 'הפרת נוהל',
                    description: 'נהלים קבועים לא בוצעו',
                },
            },
        },
        communicationType: {
            title: 'יש לבחור באחד מהנושאים הבאים',
            validation: 'אנא בחר סוג',
            options: {
                verbalExpressions: {
                    title: ({ recipient }) => `דברים שנאמרו על ידי ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'בעיות עם דברים שהם אמרו בעל פה',
                },
                writtenMessages: {
                    title: ({ recipient }) => `דברים שנכתבו על ידי ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'בעיות עם תקשורת כתובה',
                },
                bodyLanguage: {
                    title: ({ recipient }) => `מחוות גופנית של ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'שפות גוף, הבעת פנים ועוד',
                },
                generalConduct: {
                    title: ({ recipient }) => `ההתנהלות הכללית של ${recipient?.personalInfo?.firstName || 'האדם הזה'} במהלך הדיון`,
                    description: 'בעיות עם התנהגות כללית בשיחות',
                },
                speechTone: {
                    title: ({ recipient }) => `סגנון הדיבור והטונציה של ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                    description: 'בעיות עם סגנון דיבור וטון קול',
                },
            },
        },
        frameworkSelection: {
            title: ({ answers, }) => {
                // Check which flow we're in based on previous steps
                if (answers?.['reporting-feedback-subject']) {
                    return 'באיזו מסגרת נמסר הדיווח?';
                }
                if (answers?.['other-information-feedback-subject']) {
                    return 'איך היה צריך להיות מטופל שיתוף המידע?';
                }
                if (answers?.['collaboration-service-type']) {
                    if (answers?.['collaboration-service-type']?.[0] === 'service-received') {
                        return 'באיזו מסגרת התקבל המענה?';
                    }
                    if (answers?.['collaboration-service-type']?.[0] ===
                        'collaboration-happened') {
                        return 'באיזו מסגרת שיתוף הפעולה התקיים?';
                    }
                }
                if (answers?.['communication-type-selection']) {
                    return 'באיזו מסגרת התקשורת התבצעה?';
                }
                if (answers?.['expectations-setting-subject-selection']) {
                    return 'באיזו מסגרת התבצע תיאום הציפיות?';
                }
                // Check if this is from the praise wizard expectations flow
                if (answers?.['reason-selection']?.[0] === 'meeting-expectations') {
                    return 'באיזו מסגרת היו צריכות להיקבע הציפיות?';
                }
                // Fallback to generic
                return 'איך זה היה צריך להיות מטופל?';
            },
        },
        serviceFrameworkSelection: {
            title: 'באיזו מסגרת זה קרה?',
            description: 'בחר את ההקשר שבו התרחשה בעיית השירות',
            validation: 'אנא בחר מסגרת',
        },
        // Feedback-specific descriptions for common reason options
        reasonSelection: {
            title: ({ recipient }) => `לאיזה עניין מתייחס האירוע שלך עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
            validation: 'אנא בחר סיבה',
            options: {
                collaboration: {
                    title: ({ recipient }) => `מענה מצד ${recipient?.personalInfo?.firstName || 'האדם הזה'} / שיתוף פעולה עם ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                scheduleAgreement: {
                    title: ({ recipient }) => `אי עמידה בלוח זמנים / אי קיום סיכום / הפרת נוהל / אי עמידה ביעד מצד ${recipient?.personalInfo?.firstName || 'האדם הזה'}`,
                },
                communication: {
                    title: ({ recipient }) => `אופן התקשורת של ${recipient?.personalInfo?.firstName || 'האדם הזה'} (כולל דברים שנאמרו או נכתבו ומחוות גופניות)`,
                },
                informationSharing: {
                    title: ({ recipient }) => `ההתנהלות של ${recipient?.personalInfo?.firstName || 'האדם הזה'} בנוגע לשיתוף במידע / מסירת דיווח / שיתוף בתהליך קבלת החלטה`,
                },
                praiseFeedback: {
                    title: ({ recipient }) => `ההתנהלות של ${recipient?.personalInfo?.firstName || 'האדם הזה'} ביצירת שיחה של I See U ו/או I Need U`,
                },
                meetingExpectations: {
                    title: ({ recipient }) => `ההתנהלות של ${recipient?.personalInfo?.firstName || 'האדם הזה'} בנוגע לביצוע תיאום ציפיות`,
                },
            },
        },
        goalSelection: {
            title: ({ recipient, answers, }) => {
                const reasonToTitle = {
                    communication: `איזה מהיעדים שלך נפגע כתוצאה מאופן התקשורת של ${recipient?.personalInfo?.firstName || 'האדם הזה'} במהלך הדיון?`,
                    'expectations-setting': `איזה מהיעדים שלך נפגע כתוצאה מההתנהלות של ${recipient?.personalInfo?.firstName || 'האדם הזה'} בנוגע לתיאום הציפיות?`,
                    default: `איזה מהיעדים שלך מושפע מ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
                };
                const scheduleAgreementTypeToTitle = {
                    'goal-not-met': `איזה מהיעדים שלך נפגע כתוצאה מאי העמידה של  ${recipient?.personalInfo?.firstName || 'האדם הזה'} ביעד?`,
                    'schedule-not-kept': `איזה מהיעדים שלך נפגע כתוצאה מאי העמידה של  ${recipient?.personalInfo?.firstName || 'האדם הזה'} בלוח הזמנים?`,
                    'agreement-not-kept': `איזה מהיעדים שלך נפגע כתוצאה מאי קיום הסיכום או ההבטחה מצד ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
                    'procedure-not-followed': `איזה מהיעדים שלך נפגע כתוצאה מהפרת הנוהל על ידי ${recipient?.personalInfo?.firstName || 'האדם הזה'}?`,
                };
                const collaborationServiceTypeToTitle = {
                    'service-not-received': `איזה מהיעדים שלך נפגע כתוצאה מכך שלא קיבלת מענה מ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'service-received': `איזה מהיעדים שלך נפגע כתוצאה מהמענה מצד  ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'collaboration-not-happened': `איזה מהיעדים שלך נפגע כתוצאה מהעדר שיתוף פעולה עם  ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'collaboration-happened': `איזה מהיעדים שלך נפגע כתוצאה משיתוף הפעולה עם ${recipient?.personalInfo?.firstName || 'this person'}?`,
                };
                const informationSharingTypeToTitle = {
                    'decision-making-involvement': `איזה מהיעדים שלך נפגע כתוצאה מההתנהלות של ${recipient?.personalInfo?.firstName || 'this person'} בנוגע לשיתוף בתהליך קבלת ההחלטה?`,
                    reporting: `איזה מהיעדים שלך נפגע כתוצאה מההתנהלות של ${recipient?.personalInfo?.firstName || 'this person'} בנוגע למסירת הדיווח?`,
                    'other-information-sharing': `איזה מהיעדים שלך נפגע כתוצאה מההתנהלות של ${recipient?.personalInfo?.firstName || 'this person'} בנוגע לשיתוף המידע?`,
                };
                const praiseFeedbackTypeToTitle = {
                    'praise-expected-not-received': `איזה מהיעדים שלך נפגע כתוצאה מכך שלא התקבל I See U מ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'feedback-expected-not-received': `איזה מהיעדים שלך נפגע כתוצאה מכך שלא התקבל I Need U מ${recipient?.personalInfo?.firstName || 'this person'}?`,
                    'inappropriate-feedback-received': `איזה מהיעדים שלך נפגע כתוצאה מה I Need U הלא הולם של${recipient?.personalInfo?.firstName || 'this person'}?`,
                };
                if (answers?.['reason-selection']?.[0] === 'collaboration-service') {
                    return collaborationServiceTypeToTitle[answers?.['collaboration-service-type']?.[0]];
                }
                if (answers?.['reason-selection']?.[0] === 'schedule-agreement') {
                    return scheduleAgreementTypeToTitle[answers?.['schedule-agreement-type']?.[0]];
                }
                if (answers?.['reason-selection']?.[0] === 'information-sharing') {
                    return informationSharingTypeToTitle[answers?.['information-sharing-subject-selection']?.[0]];
                }
                if (answers?.['reason-selection']?.[0] === 'praise-feedback') {
                    return praiseFeedbackTypeToTitle[answers?.['praise-feedback-subject-selection']?.[0]];
                }
                return (reasonToTitle[answers?.['reason-selection']?.[0]] || reasonToTitle.default);
            },
            validation: 'אנא בחר יעד',
        },
        goalImpactRange: {
            title: 'באיזו מידה זה פוגע בסיכויים שלך להשיג את היעד?',
            validation: 'אנא דרג את ההשפעה',
            options: {
                relativelyReduced: {
                    title: 'במידה מועטה',
                },
                significantlyReduced: {
                    title: 'במידה רבה',
                },
                extremelyReduced: {
                    title: 'במידה רבה מאוד',
                },
            },
        },
        additionalEffectsTemp: {
            title: 'באיזה דרכים נוספות זה משפיע עליך לרעה?',
            validation: 'אנא בחר לפחות השפעה אחת',
            options: {
                energy: {
                    title: 'גרם להשקעת אנרגיה מיותרת',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} גרמה להשקעת אנרגיה מיותרת, ביחס ל${impacted}`,
                    afterSend: (name, impacted) => `גרמת ל${name} להשקעת אנרגיה מיותרת, ביחס ל${impacted}`,
                },
                confidence: {
                    title: 'פגיע בתחושת הביטחון שלי',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} פגעה בתחושת הביטחון שלך, ביחס ל${impacted}`,
                    afterSend: (name, impacted) => `פגעת בתחושת הביטחון של ${name}, ביחס ל${impacted}`,
                },
                reputation: {
                    title: 'פגע במוניטין המקצועי שלי',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} פגעה במוניטין המקצועי שלך, בעיני ${impacted}`,
                    afterSend: (name, impacted) => `פגעת במוניטין המקצועי של ${name}, בעיני ${impacted}`,
                },
                belonging: {
                    title: 'פגע בתחושת השייכות שלי',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} פגעה בתחושת השייכות שלך, ביחס ל${impacted}`,
                    afterSend: (name, impacted) => `פגעת בתחושת השייכות של ${name}, ביחס ל${impacted}`,
                },
                responsibility: {
                    title: 'פגע ביכולת שלי ליזום ולקחת יותר אחריות',
                    beforeSend: (name, impacted) => `ההתנהלות של ${name} פגעה ביכולת שלך ליזום ולקחת יותר אחריות, מול ${impacted}`,
                    afterSend: (name, impacted) => `פגעת ביכולת של ${name} ליזום ולקחת יותר אחריות, מול ${impacted}`,
                },
                learning: {
                    title: 'פגע ביכולת שלי ללמוד ולהתפתח',
                    beforeSend: (name) => `ההתנהלות של ${name} פגעה ביכולת שלך ללמוד ולהתפתח`,
                    afterSend: (name) => `פגעת ביכולת של ${name} ללמוד ולהתפתח`,
                },
                'no-other-effects': {
                    title: 'לא השפיע עליי מבחינות נוספות',
                },
                connection: {
                    title: 'יצר תחושת ריחוק בינינו',
                    beforeSend: (name) => `ההתנהלות של ${name} יצרה תחושת ריחוק בינך לבין ${name}`,
                    afterSend: (name) => `יצרת תחושת ריחוק בינך לבין ${name}`,
                },
                meaningful: {
                    title: 'פגע בתחושת המשמעות שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} פגעה בתחושת המשמעות שלך`,
                    afterSend: (name) => `פגעת בתחושת המשמעות של ${name}`,
                },
            },
        },
        additionalEffects: {
            title: 'באיזה דרכים נוספות זה משפיע עליך?',
            validation: 'אנא בחר לפחות השפעה אחת',
            options: {
                energy: {
                    title: 'גרם להשקעת אנרגיה מיותרת',
                    beforeSend: (_name) => `נאלצת להשקיע אנרגיה מיותרת`,
                    afterSend: (name) => `בעקבות האירוע, נדרשה מ${name} השקעת אנרגיה מיותרת`,
                },
                confidence: {
                    title: 'ירידה בתחושת הביטחון שלי',
                    beforeSend: (_name) => `ירידה בתחושת הבטחון שלך`,
                    afterSend: (name) => `בעקבות האירוע, חלה אצל ${name} ירידה בתחושת הבטחון`,
                },
                reputation: {
                    title: 'ירידה במוניטין המקצועי שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} גרמה לירידה במוניטין המקצועי שלך`,
                    afterSend: (name) => `בעקבות האירוע, המוניטין המקצועי של ${name} עורער`,
                },
                belonging: {
                    title: 'ירידה בתחושת השייכות שלי',
                    beforeSend: (_name) => `ירידה בתחושת השייכות`,
                    afterSend: (name) => `בעקבות האירוע, חלה אצל ${name} ירידה בתחושת השייכות`,
                },
                responsibility: {
                    title: 'ירידה ביכולת שלי ליזום ולקחת יותר אחריות',
                    beforeSend: (name) => `ההתנהלות של ${name} גרמה לירידה ביכולת שלך ליזום ולקחת יותר אחריות`,
                    afterSend: (name) => `בעקבות האירוע, חלה אצל ${name} ירידה ביכולת ליזום ולקחת יותר אחריות`,
                },
                learning: {
                    title: 'ירידה ביכולת שלי ללמוד ולהתפתח',
                    beforeSend: (name) => `ההתנהלות של ${name} גרמה לירידה ביכולת שלך ללמוד ולהתפתח`,
                    afterSend: (name) => `בעקבות האירוע, חלה אצל ${name} ירידה ביכולת ללמוד ולהתפתח`,
                },
                'no-other-effects': {
                    title: 'לא השפיע עליי מבחינות נוספות',
                },
                connection: {
                    title: 'יצר תחושת ריחוק בינינו',
                    beforeSend: (name) => `ההתנהלות של ${name} יצרה תחושת ריחוק בינך לבין ${name}`,
                    afterSend: (name) => `בעקבות האירוע, נוצרה אצל ${name} תחושת ריחוק`,
                },
                meaningful: {
                    title: 'ירידה בתחושת המשמעות שלי',
                    beforeSend: (name) => `ההתנהלות של ${name} גרמה לירידה בתחושת המשמעות שלך`,
                    afterSend: (name) => `בעקבות האירוע, חלה ירידה בתחושת המשמעות אצל ${name}`,
                },
            },
        },
        // Negative Effects Follow-up Step (Generic)
        additionalEffectsDetails: {
            validation: 'אנא בחר אפשרות',
            title: ({ answers }) => {
                const selectedEffects = answers?.['additional-effects'];
                if (Array.isArray(selectedEffects)) {
                    const followUpOptions = [
                        'energy',
                        'confidence',
                        'reputation',
                        'belonging',
                        'responsibility',
                    ];
                    const selectedFollowUps = selectedEffects.filter((effect) => followUpOptions.includes(effect));
                    if (selectedFollowUps.length > 0) {
                        // Sort effects in consistent order to match i18n keys
                        const sortedEffects = selectedFollowUps.sort((a, b) => {
                            return followUpOptions.indexOf(a) - followUpOptions.indexOf(b);
                        });
                        // Create a comma-separated list of effect keys for i18n lookup
                        const effectsList = sortedEffects.join(',');
                        const effectsToTitle = {
                            energy: 'ביחס למי הרגשת שהיית צריך להשקיע אנרגיה מיותרת?',
                            confidence: 'ביחס למי איבדת ביטחון?',
                            reputation: 'בעיני מי המוניטין שלך נפגע?',
                            belonging: 'ביחס למי תחושת השייכות שלך נפגעה?',
                            responsibility: 'ביחס למי היכולת שלך לקחת אחריות נפגעה?',
                            'energy,confidence': 'ביחס למי היית צריך להשקיע אנרגיה מיותרת ואיבדת ביטחון?',
                            'energy,reputation': 'ביחס למי היית צריך להשקיע אנרגיה מיותרת והמוניטין שלך נפגע?',
                            'energy,belonging': 'ביחס למי היית צריך להשקיע אנרגיה מיותרת ותחושת השייכות שלך נפגעה?',
                            'energy,responsibility': 'ביחס למי היית צריך להשקיע אנרגיה מיותרת והיכולת שלך לקחת אחריות נפגעה?',
                            'confidence,reputation': 'ביחס למי איבדת ביטחון והמוניטין שלך נפגע?',
                            'confidence,belonging': 'ביחס למי איבדת ביטחון ותחושת השייכות שלך נפגעה?',
                            'confidence,responsibility': 'ביחס למי איבדת ביטחון והיכולת שלך לקחת אחריות נפגעה?',
                            'reputation,belonging': 'ביחס למי המוניטין שלך נפגע ותחושת השייכות שלך נפגעה?',
                            'reputation,responsibility': 'ביחס למי המוניטין שלך נפגע והיכולת שלך לקחת אחריות נפגעה?',
                            'belonging,responsibility': 'ביחס למי תחושת השייכות שלך והיכולת שלך לקחת אחריות נפגעו?',
                            'energy,confidence,reputation': 'ביחס למי הושפעת מהבעיות הללו?',
                            'energy,confidence,belonging': 'ביחס למי הושפעת מהבעיות הללו?',
                            'energy,confidence,responsibility': 'ביחס למי הושפעת מהבעיות הללו?',
                            'energy,reputation,belonging': 'ביחס למי הושפעת מהבעיות הללו?',
                            'energy,reputation,responsibility': 'ביחס למי הושפעת מהבעיות הללו?',
                            'energy,belonging,responsibility': 'ביחס למי הושפעת מהבעיות הללו?',
                            'confidence,reputation,belonging': 'ביחס למי הושפעת מהבעיות הללו?',
                            'confidence,reputation,responsibility': 'ביחס למי הושפעת מהבעיות הללו?',
                            'confidence,belonging,responsibility': 'ביחס למי הושפעת מהבעיות הללו?',
                            'reputation,belonging,responsibility': 'ביחס למי הושפעת מהבעיות הללו?',
                            generic: 'ביחס למי הושפעת?',
                        };
                        return effectsToTitle[effectsList] || effectsToTitle.generic;
                    }
                }
                // Fallback to generic title
                return 'ביחס למי הושפעת?';
            },
        },
        // Relation Options (shared across negative effects follow-up questions)
        relationOptions: {
            everyone: 'כולם',
            recipient: 'האדם המעורב',
            employees: 'העובדים שלי',
            customers: 'הלקוחות שלי',
            suppliers: 'הספקים שלי',
            manager: 'המנהל שלי',
            team: 'הצוות שלנו',
            colleagues: 'העמיתים שלי',
            seniorManagement: 'ההנהלה הבכירה',
        },
        collaborationServiceDescription: {
            validation: 'אנא ספק פרטים על המצב',
            title: ({ answers }) => {
                const serviceTypeToTitle = {
                    'service-not-received': 'באיזה מענה מדובר?',
                    'service-received': 'באיזה מענה מדובר?',
                    'collaboration-not-happened': 'באיזה סוג של שיתוף פעולה מדובר?',
                    'collaboration-happened': 'באיזה סוג של שיתוף פעולה מדובר?',
                };
                const serviceType = answers?.['collaboration-service-type'];
                return serviceTypeToTitle[serviceType] || 'ספק פרטים על המצב';
            },
        },
        scheduleAgreementDescription: {
            validation: 'אנא תאר מה קרה',
            title: ({ answers }) => {
                const scheduleTypeToTitle = {
                    'goal-not-met': 'באיזה יעד מדובר',
                    'schedule-not-kept': 'מהו לוח הזמנים שסוכם עליו?',
                    'agreement-not-kept': 'מה סוכם או הובטח?',
                    'procedure-not-followed': 'על איזה נוהל מדובר?',
                };
                const scheduleType = answers?.['schedule-agreement-type'];
                return scheduleTypeToTitle[scheduleType] || 'ספק פרטים על מה שקרה';
            },
        },
        verbalExpressionsDescription: {
            title: ({ recipient }) => `אילו מילים או משפטים נאמרו על ידי ${recipient?.personalInfo?.firstName || 'הם'}?`,
            placeholder: 'תאר מה נאמר...',
            validation: 'אנא תאר מה נאמר',
        },
        writtenMessagesDescription: {
            title: ({ recipient }) => `אילו מילים או משפטים נכתבו על ידי ${recipient?.personalInfo?.firstName || 'הם'}?`,
            placeholder: 'תאר מה נכתב...',
            validation: 'אנא תאר מה נכתב',
        },
        bodyLanguageDetails: {
            title: ({ recipient }) => `לאיזה מחווה גופנית של ${recipient?.personalInfo?.firstName || 'האדם הזה'} המשוב שלך מתייחס ?`,
            validation: 'אנא בחר מחווה',
            options: {
                lookOfSurprise: { title: 'הבעת פנים מופתעת' },
                lookOfDisrespect: { title: 'הבעת פנים מזלזלת' },
                offendedLook: { title: 'הבעת פנים נעלבת' },
                staring: { title: 'מבט בוהה' },
                angeredLook: { title: 'הבעת פנים כעוסה' },
                hittingTable: { title: 'דפיקה חזקה על השולחן' },
                headHolding: { title: 'החזקת ראש' },
                waiveDismissal: { title: 'נפנוף (תנועת ביטול)' },
                quickSharpMovements: { title: 'תנועות מהירות וחדות' },
                foldedArms: { title: 'שילוב ידיים' },
            },
        },
        speechToneDetails: {
            title: ({ recipient }) => `לאיזה היבט בסגנון הדיבור של ${recipient?.personalInfo?.firstName || 'האדם הזה'} המשוב שלך מתייחס?`,
            validation: 'אנא בחר היבט דיבור',
            options: {
                laughingInappropriately: { title: 'צחוק בעיתוי בעייתי' },
                speakingQuietly: { title: 'דיבור בטון חלש ושקט' },
                speakingFast: { title: 'קצב דיבור מהיר' },
                suddenVoiceRaise: { title: 'הרמת קול פתאומית' },
                snickering: { title: 'גיחוך' },
                highTone: { title: 'דיבור בטונים גבוהים יחסית' },
            },
        },
        generalConductDetails: {
            title: ({ recipient }) => `לאיזה היבט בהתנהלות הכללית של ${recipient?.personalInfo?.firstName || 'האדם הזה'} אתה מתייחס?`,
            validation: 'אנא בחר היבט התנהלות',
            options: {
                leavingEarly: { title: 'עזיבת הישיבה בטרם סיומה' },
                arrivingLate: { title: 'הגעה באיחור לישיבה' },
                interruptingOthers: { title: 'כניסה לתוך דברי האחר/ים' },
                speakingTooLong: { title: 'הארכה בדיבור ביחס לזמן הנתון' },
                switchingTopics: { title: 'דילוג מנושא לנושא' },
                notFocusing: {
                    title: 'התמקדות בעניינים אחרים, במקום בשיח ובדובר/ים',
                },
                reducingOthersExpression: {
                    title: 'צמצום האפשרות של האחר/ים להתבטא',
                },
                prematureConclusions: { title: 'גיבוש מסקנות מראש ללא שיח מקדים' },
                notInvolvedEnough: { title: 'מעורבות יחסית מועטה במהלך הדיון' },
                arguingTooMuch: { title: 'וכחנות ועיסוק מוגזם בשאלה מי צודק' },
            },
        },
        praiseFeedbackSubjectSelection: {
            title: ({ recipient }) => `למה מתייחס ה I Need U שלך ל${recipient?.personalInfo?.firstName || 'הם'}?`,
            validation: 'אנא בחר נושא משוב',
            options: {
                praiseExpectedNotReceived: {
                    title: 'ל I See U שציפיתי שיינתן לי או לעובד/ים אחר/ים, אבל לא התקבל',
                    description: 'I See U צפוי שלא ניתן',
                },
                inappropriateFeedbackReceived: {
                    title: 'I Need U לא מתאים שאני או עובד/ים אחר/ים קיבלנו',
                    description: 'I Need U שניתן אבל הועבר בצורה לא מתאימה',
                },
                feedbackExpectedNotReceived: {
                    title: 'ל I Need U שציפיתי שיינתן לי או לעובד/ים אחר/ים, אבל לא התקבל',
                    description: 'I Need U צפוי שלא ניתן',
                },
            },
        },
        informationSharingSubjectSelection: {
            title: 'באיזה סוג של שיתוף במידע מדובר?',
            validation: 'אנא בחר סוג שיתוף מידע',
            options: {
                decisionMakingInvolvement: {
                    title: 'שיתוף בתהליך קבלת החלטה הנוגעת לתחום אחריותי',
                    description: 'בעיות עם מעורבות בקבלת החלטות',
                },
                reporting: {
                    title: 'מסירת דיווח',
                    description: 'בעיות עם דיווח או קבלת דיווחים',
                },
                otherInformationSharing: {
                    title: 'שיתוף במידע אחר',
                    description: 'בעיות עם שיתוף סוגים אחרים של מידע',
                },
            },
        },
        decisionMakingFeedbackSubject: {
            title: 'למה מתייחס המשוב שלך?',
            validation: 'אנא בחר בעיית קבלת החלטות',
            options: {
                decisionNotInvolving: {
                    title: 'לא שותפתי בתהליך קבלת ההחלטה',
                    description: 'החלטה התקבלה ללא מעורבותך',
                },
                partialDecisionInvolving: {
                    title: 'השיתוף בתהליך קבלת ההחלטה היה חלקי בלבד',
                    description: 'עורבת אבל לא במלואה בקבלת ההחלטות',
                },
            },
        },
        decisionMakingDetails: {
            title: 'תאר את ההחלטה שהתקבלה',
            validation: 'אנא תאר את פרטי קבלת ההחלטות',
        },
        reportingFeedbackSubject: {
            title: 'למה מתייחס המשוב שלך?',
            validation: 'אנא בחר בעיית דיווח',
            options: {
                reportNotReceived: {
                    title: 'הדיווח לא נמסר לי',
                    description: 'דיווח שציפית לו לא התקבל',
                },
                reportReceivedLate: {
                    title: 'הדיווח נמסר לי באיחור',
                    description: 'הדיווח התקבל אבל באיחור',
                },
                reportPartialReceived: {
                    title: 'נמסר לי דיווח חלקי בלבד',
                    description: 'התקבל רק חלק מהדיווח הצפוי',
                },
                reportReceivedAfterOthers: {
                    title: 'הדיווח נמסר לי רק בדיעבד, לאחר שכבר נמסר לגורם אחר ',
                    description: 'הדיווח נמסר לאחרים לפני שהתקבל אצלך',
                },
            },
        },
        reportingDetails: {
            title: 'מה נושא הדיווח',
            validation: 'אנא תאר את פרטי הדיווח',
        },
        reportingFramework: {
            title: 'איך היה צריך להיות מטופל הדיווח?',
            validation: 'אנא בחר מסגרת',
        },
        otherInformationFeedbackSubject: {
            title: 'למה מתייחס המשוב שלך?',
            validation: 'אנא בחר בעיית שיתוף מידע',
            options: {
                informationNotReceived: {
                    title: 'אי קבלת המידע',
                    description: 'מידע שציפית לו לא התקבל',
                },
                informationPartialReceived: {
                    title: 'קבלת מידע חלקי',
                    description: 'התקבל רק חלק מהמידע הצפוי',
                },
                informationReceivedDelayed: {
                    title: 'איחור בקבלת המידע',
                    description: 'המידע התקבל אבל באיחור',
                },
                informationReceivedAfterOthers: {
                    title: 'קבלת המידע אחרי שכבר נמסר למישהו אחר',
                    description: 'המידע נמסר לאחרים לפני שהתקבל אצלך',
                },
            },
        },
        otherInformationDetails: {
            title: ({ answers, }) => {
                if (answers?.['other-information-feedback-subject']?.[0] ===
                    'information-not-received') {
                    return 'תאר את המידע שלא שותף';
                }
                return 'תאר את המידע ששותף';
            },
            validation: 'אנא תאר את פרטי שיתוף המידע',
        },
        otherInformationFramework: {
            title: 'איך היה צריך להיות מטופל שיתוף המידע?',
            validation: 'אנא בחר מסגרת',
        },
        expectationsSettingSubjectSelection: {
            title: 'למה מתייחס המשוב שלך?',
            validation: 'אנא בחר בעיית ציפיות',
            options: {
                partialExpectationsSet: {
                    title: 'תיאום הציפיות שבוצע מולי היה חלקי בלבד',
                    description: 'ציפיות נקבעו אבל היו לא שלמות',
                },
                noExpectationsSet: {
                    title: 'לא בוצע מולי תיאום ציפיות',
                    description: 'בכלל לא נקבעו ציפיות',
                },
            },
        },
        expectationsSettingDetails: {
            title: ({ recipient, answers, }) => {
                if (answers?.['expectations-setting-subject-selection']?.[0] ===
                    'partial-expectations-set') {
                    return 'באיזה תחום התבצע תיאם ציפיות?';
                }
                if (answers?.['expectations-setting-subject-selection']?.[0] ===
                    'no-expectations-set') {
                    return 'איזה תיאום ציפיות היה צריך להתבצע מבחינתך?';
                }
                return `In which area did ${recipient?.personalInfo?.firstName || 'they'} set expectations?`;
            },
            validation: 'אנא תאר את פרטי תיאום הציפיות',
        },
        stakeholderSelection: {
            title: 'ביחס למי?',
            validation: 'אנא בחר בעלי עניין',
            options: {
                everyone: {
                    title: 'כולם',
                    description: 'באופן כללי, ביחס לכולם',
                },
                recipient: {
                    title: 'האדם המעורב',
                    description: 'ביחס לנמען המשוב',
                },
                myEmployees: {
                    title: 'העובדים שלי',
                    description: 'ביחס לאנשים שמדווחים לי',
                },
                myManager: {
                    title: 'המנהל שלי',
                    description: 'ביחס למפקח הישיר שלי',
                },
                colleagues: {
                    title: 'העמיתים שלי',
                    description: 'ביחס לעמיתים ועמיתי עבודה',
                },
                myCustomers: {
                    title: 'לקוחות/לקוחות',
                    description: 'ביחס ללקוחות חיצוניים',
                },
                mySuppliers: {
                    title: 'הספקים שלי',
                    description: 'ביחס לספקים שלי',
                },
                seniorManagement: {
                    title: 'הנהלה הבכירה',
                    description: 'ביחס להנהלה הבכירה',
                },
                ourTeam: {
                    title: 'הצוות שאנחנו בו',
                    description: 'ביחס לצוות שאנחנו בו',
                },
                myColleagues: {
                    title: 'העמיתים שלי',
                    description: 'ביחס לעמיתים ועמיתי עבודה',
                },
            },
        },
        organizationalImpactRange: {
            title: 'באיזו מידה זה משפיע על הארגון?',
            description: 'דרג את ההשפעה הארגונית של הבעיה',
            options: {
                aLittle: {
                    title: 'קצת',
                    description: 'השפעה ארגונית מינורית',
                },
                somewhat: {
                    title: 'במידה מסוימת',
                    description: 'השפעה ארגונית מתונה',
                },
                quiteABit: {
                    title: 'די הרבה',
                    description: 'השפעה ארגונית משמעותית',
                },
                aLot: {
                    title: 'הרבה',
                    description: 'השפעה ארגונית גדולה',
                },
            },
        },
        companyValues: {
            title: 'האם זה פוגע בערכי החברה?',
        },
        success: {
            title: '🎯 תודה לך על המשוב!',
            description: 'המשוב הבונה שלך נרשם ויעזור לשפר את מקום העבודה שלנו.',
        },
        review: {
            title: {
                creator: 'I Need U',
                receiver: 'I Need U',
            },
            subtitle: {
                creator: 'בחרת להתחיל שיחה עם {{employeeName}}',
                receiver: 'קיבלת I Need U מ{{employeeName}}',
            },
            description: '',
            date: 'מועד האירוע / הדיון שאליו מתייחסת השיחה',
            reason: 'נושא השיחה',
            additionalEffectsTitle: 'השלכות נוספות של האירוע',
            companyValues: 'השפעה על ערכי החברה',
            edit: 'ערוך',
            saveDraft: 'שמור כטיוטה',
            send: 'שלח',
            sending: 'שולח...',
            reasonDetails: 'תיאור האירוע',
            goal: {
                title: {
                    creator: 'ההשפעה של האירוע על ההצלחה שלך',
                    receiver: 'ההשפעה של האירוע על ההצלחה של {{employeeName}}',
                },
                prefixBeforeSend: {
                    creator: 'הסיכויים שלך לעמוד ביעד',
                    receiver: 'הסיכויים של {{employeeName}} לעמוד ביעד',
                },
                prefixAfterSend: 'הסיכויים של {{employeeName}} לעמוד ביעד',
                affection: 'הצטמצמו',
            },
            reasonPrefixes: {
                'collaboration-service': 'בעיית תגובה/שירות עם',
                'schedule-agreement': 'בעיית לוח זמנים/הסכם עם',
                communication: 'בעיית תקשורת עם',
                'information-sharing': 'בעיית שיתוף מידע עם',
                'decision-making': 'בעיית תהליך קבלת החלטות עם',
                reporting: 'בעיית דיווח עם',
                'other-information': 'בעיית מידע אחר עם',
                'expectations-setting': 'בעיית הגדרת ציפיות עם',
            },
            additionalEffectsMap: {
                frustrated: 'מתוסכל',
                confused: 'מבולבל',
                disappointed: 'מאוכזב',
                concerned: 'מודאג',
                worried: 'חרד',
                stressed: 'לחוץ',
            },
            additionalEffectsPrefix: 'גרם לך להרגיש',
        },
    },
    debriefQuestions: {
        type: {
            title: 'איזה שיח להפקת לקחים נדרש?',
            personal: 'הפקת לקחים אישית',
            group: 'הפקת לקחים קבוצתית',
        },
        debriefSubmittedSuccessfully: 'התחקיר נשלח בהצלחה',
        debriefSubmittedFailed: 'נכשל לשלוח את התחקיר',
        signalsUpdatedSuccessfully: 'הלקחים עודכנו בהצלחה',
        signalUpdateFailed: 'נכשל לעדכן את הלקחים',
        title: 'אשף תחקיר',
        description: 'כאן תוכל לתחקר אירוע',
        debriefLeader: {
            title: 'מי המנהל הראשי של התחקיר?',
            description: 'מי המנהר הראשי של התחקיר?',
        },
        debriefGoalSelection: {
            title: 'איזה יעד הושפע מהאירוע?',
        },
        debriefCrucialParticipants: {
            title: 'מי היו השותפים העיקריים במאורע של התחקיר?',
        },
        debriefNonCrucialParticipants: {
            title: 'מי היו השותפים שאינם עיקריים במאורע של התחקיר?',
        },
        debriefViewers: {
            title: 'מי האנשים שיכולים לצפות בתחקיר?',
        },
        expectedResult: {
            title: 'מה הייתה התוצאה שרצינו להשיג?',
            achievedResult: {
                title: 'תוצאה שהושגה',
            },
            notAchievedResult: {
                title: 'תוצאה שלא הושגה',
            },
            textAreaLabel: 'תיאור התוצאה הרצויה',
        },
        facts: {
            title: 'מהן העובדות של האירוע הנדון?',
            description: 'רצוי לארגן את האירועים בסדר כרונולוגי',
        },
        topFacts: {
            title: 'מה הן העובדות המובילות (MATCH POINTS) של האירוע הנדון?',
        },
        matchPoint: {
            whatDidYouDo: {
                title: 'מהי הפעולה האחת המשמעותית ביותר שעשית או שלא עשית, שהשפיעה על ה match point?',
                iDid: 'עשיתי',
                iDidnt: 'לא עשיתי',
            },
            actions: {
                title: 'בחר פעולות',
                setClearGoals: 'הגדרת יעדים ברורה',
                defineResponsiblePerson: 'פעולה לקביעת מוביל/ה או אחראי/ת',
                performPreparation: 'הכנה מלאה',
                sharedInformation: 'שיתוף במידע עם האנשים הרלוונטים',
                actInResponseToInteraction: 'פעולה כתגובה למידע / משוב / בקשה',
                workAccordingToProcedure: 'פעולה שהיא בהתאם לנהלים/למדיניות/לתהליך העבודה',
                matchingExpectations: 'תיאום ציפיות',
                improvisation: 'מעקב ובקרה',
            },
            why: {
                title: 'למה פעלת כך?',
                skipText: 'אני לא יודע/ת למה',
                placeholder: 'כתוב כאן...',
            },
            reason: {
                title: 'ומה הסיבה לכך?',
            },
            assumption: {
                title: 'מה הייתה הנחת היסוד / האמונה / המחשבה הבסיסית שהניעה אותך להתנהל כך?',
            },
            signal: {
                title: 'מהו הלקח שלך?',
                placeholder: 'יש לכתוב את הלקח שלך כאן...',
                addMore: 'הוסף/י',
                continue: 'המשך/י ל match point הבא',
                finish: 'סיים/י',
            },
        },
        review: {
            title: 'סיכום',
            description: 'סקור וערוך את תשומות חברי הצוות עבור כל match point',
            matchPoint: 'match point {{number}}',
            edit: 'עריכה',
            saveDraft: 'שמור/י כטיוטה',
            send: 'סיום',
            sending: 'שולח...',
            achievedResult: 'תוצאה שהושגה',
            notAchievedResult: 'תוצאה שלא הושגה',
        },
        viewers: {
            selectViewers: 'בחר/י צופים',
            updateFailed: 'נכשל לעדכן את רשימת הצופים',
            updatedSuccessfully: 'רשימת הצופים עודכנה בהצלחה',
        },
    },
    stepTitles: {
        'employee-selection': 'בחירת עובד',
        'date-selection': 'בחירת תאריך',
        'reason-selection': 'בחירת סיבה',
        'goal-selection': 'בחירת מטרה',
        'goal-impact-range': 'השפעה על המטרה',
        'company-values': 'ערכי החברה',
        'additional-effects': 'השפעות נוספות',
        'additional-effects-details': 'פירוט השפעות נוספות',
        'additional-negative-effects': 'השפעות שליליות נוספות',
        'negative-effects-details': 'פירוט השפעות שליליות',
        'organizational-impact-range': 'השפעה ארגונית',
        'collaboration-service-details': 'פרטי שיתוף פעולה ושירות',
        'communication-details': 'פרטי תקשורת',
        'schedule-agreement-details': 'פרטי לוח זמנים והסכמים',
        [SharedReasonOptions.COLLABORATION_SERVICE]: 'פרטי שיתוף פעולה / מענה',
        [SharedReasonOptions.SCHEDULE_AGREEMENT]: 'פרטי לוח זמנים והסכמים',
        [SharedReasonOptions.COMMUNICATION]: 'פרטי תקשורת',
        [SharedReasonOptions.INFORMATION_SHARING]: 'פרטי שיתוף מידע',
        [SharedReasonOptions.PRAISE_FEEDBACK]: 'פרטי I see U & I need U',
        [FeedbackReasonOptions.EXPECTATIONS_SETTING]: 'פרטי הגדרת ציפיות',
        [PraiseReasonOptions.MEETING_EXPECTATIONS]: 'פרטי תיאום ציפיות',
        'manager-involvement-details': 'פרטי מעורבות מנהל',
        participants: 'משתתפים',
        'bot-invite': 'הזמנת בוט',
        'match-points': 'נקודות התאמה',
        facts: 'עובדות',
        emotions: 'רגשות',
        assumptions: 'הנחות',
        signals: 'לקחים',
        'reason-details': 'פרטי הסיבה שנבחרה',
    },
    aiTextArea: {
        input: 'הכנס טקסט',
        enrichButton: 'שדרג/י עם AI',
        enrichInProgress: 'משדרג...',
        aiVersion: 'גרסת הAI',
        useAIVersion: 'השתמש בגרסה זו',
        discard: 'מחק',
        explanation: 'הסבר:',
        error: 'הבקשה נכשלה. בבקשה נסה שוב.',
    },
    common: {
        rangeDefaults: {
            relatively: 'במידה מועטה',
            significantly: 'במידה רבה',
            extremely: 'במידה רבה מאוד',
        },
        buttons: {
            skip: 'דלג',
            previous: 'הקודם',
            next: 'הבא',
            continue: 'המשך',
            save: 'שמור',
            saving: 'שומר...',
            cancel: 'ביטול',
            startBot: 'התחל בוט',
            startWizard: 'התחל אשף',
            addAnotherSignal: '+ הוסף לקח נוסף',
            saveSignals: 'שמור לקחים',
            addFact: 'הוסף עובדה',
            addAnother: 'הוסף עוד',
            continueToNext: 'המשך להבא',
            closeDebrief: 'סיום תחקיר',
            update: 'עדכן/י',
            addSignal: 'הוסף לקח',
            addTask: 'הוסף משימה',
        },
        labels: {
            whatYouDid: 'מה עשית/לא עשית',
            whatWasYourAssumption: 'מה הייתה ההנחה שלך',
            signalsLearned: 'לקחים שנלמדו',
            debriefLeader: 'מוביל התחקיר',
            teamMember: 'חבר צוות',
            otherPerson: 'אדם אחר',
            additionalParticipant: 'משתתף נוסף',
            progress: 'התקדמות',
            factsList: 'רשימת עובדות',
            viewAllFacts: 'הצג את כל העובדות',
            closedAt: 'נסגר ב',
            startedAt: 'התחיל ב',
            interactionDescription: 'הערות נוספות',
        },
        placeholders: {
            enterFactPlaceholder: 'הזן עובדה ולחץ Ctrl+Enter / Alt + Enter...',
            enterSignalPlaceholder: 'הזן לקח...',
            writeHerePlaceholder: 'כתוב כאן...',
            selectOption: 'בחר אפשרות',
            interactionDescription: 'הוסף הערות...',
        },
        messages: {
            noEmployeeSelected: 'לא נבחר עובד',
            participantNotFilledBot: 'משתתף זה עדיין לא מילא את הבוט',
            noMatchPoints: 'לא נמצאו נקודות התאמה. אנא השלם את השלבים הקודמים.',
            maxFactsReached: 'הגעת למספר המקסימלי של עובדות ({{count}}).',
            minFactsRequired: 'אנא הוסף לפחות {{count}} עובד{{plural}}.',
            maxItemsSelected: 'מספר הפריטים המקסימלי נבחר ({{count}})',
            entriesCount: '{{current}} / {{min}} רשומות',
            itemsSelectedSingular: 'פריט אחד נבחר',
            itemsSelectedPlural: '{{count}} פריטים נבחרו',
            selectUpToSingular: 'בחר פריט אחד',
            selectUpToPlural: 'בחר עד {{count}} פריטים',
            selectedCount: '{{max}} / {{count}} נבחרו',
            noFactsYet: 'עדיין לא נוספו עובדות. הוסף את העובדה הראשונה שלך למטה.',
            viewersUpdatedSuccessfully: 'רשימת הצופים עודכנה בהצלחה',
            failedToUpdateViewers: 'כישלון בעת עידכון רשימת הצופים',
        },
        goalsChoice: {
            noEffect: {
                title: 'אירוע זה אינו משפיע על היעדים שלי',
            },
        },
        companyValuesChoice: {
            noEffect: {
                title: 'לא הייתה השפעה על ערכי החברה',
            },
        },
        exit: {
            exitWizard: 'יציאה מהתהליך',
            title: 'לצאת מהתהליך?',
            description: 'האם אתה בטוח שברצונך לצאת? ההתקדמות שלך לא תישמר.',
            exit: 'יציאה',
        },
        debug: {
            debugInfo: 'מידע דיבאג',
        },
    },
});
